export const TIMELINE_REQUEST = 'TIMELINE_REQUEST';
export const TIMELINE_SUCCESS = 'TIMELINE_SUCCESS';
export const TIMELINE_FAILURE = 'TIMELINE_FAILURE';

export const TIMELINE_REQUEST_FUTURE = 'TIMELINE_REQUEST_FUTURE';
export const TIMELINE_SUCCESS_FUTURE = 'TIMELINE_SUCCESS_FUTURE';
export const TIMELINE_FAILURE_FUTURE = 'TIMELINE_FAILURE_FUTURE';

export const TIMELINE_REQUEST_PAST = 'TIMELINE_REQUEST_PAST';
export const TIMELINE_SUCCESS_PAST = 'TIMELINE_SUCCESS_PAST';
export const TIMELINE_FAILURE_PAST = 'TIMELINE_FAILURE_PAST';
